export default IconArrowBarLeft => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-arrow-bar-left" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 12l10 0" />
  <path d="M4 12l4 4" />
  <path d="M4 12l4 -4" />
  <path d="M20 4l0 16" />
</svg>`;